export function computePartialCosts(rawMaterials) {
  return rawMaterials.map((item) => {
    const copy = { ...item };

    const usedQty = parseFloat(copy.quantity);
    const stockQty = parseFloat(copy.stock_quantity);
    const stockCost = parseFloat(copy.cost);

    if (
      !isNaN(usedQty) &&
      !isNaN(stockQty) &&
      stockQty > 0 &&
      !isNaN(stockCost)
    ) {
      const partialCost = (usedQty / stockQty) * stockCost;
      copy.partial_cost = partialCost.toFixed(2);
    } else {
      copy.partial_cost = "0.00";
    }

    return copy;
  });
}

export function computePartialCostsComponent(rawMaterials) {
  return rawMaterials.map((item) => {
    const copy = { ...item };

    const usedQty = parseFloat(copy.quantity);
    const stockQty = parseFloat(copy.stock_quantity);
    const stockCost = parseFloat(copy.cost);

    if (
      !isNaN(usedQty) &&
      !isNaN(stockQty) &&
      stockQty > 0 &&
      !isNaN(stockCost)
    ) {
      const partialCost = usedQty * stockCost;
      copy.partial_cost = partialCost.toFixed(2);
    } else {
      copy.partial_cost = "0.00";
    }

    return copy;
  });
}

export function computeTotalCost(rawMaterials) {
  console.log("RAAW COM,", rawMaterials);
  return rawMaterials
    .reduce((sum, item) => {
      return sum + parseFloat(item.partial_cost || "0");
    }, 0)
    .toFixed(2);
}

export function formatCost(value) {
  return parseFloat(value || 0).toFixed(2);
}
